import useSearchWords from "hooks/useSearchWords";
import useQuery from "hooks/useQuery";

export interface JobIdsPropsHook {
  searchWords: string[];
}

export default function useJobIdsProps(): JobIdsPropsHook {
  const [query] = useQuery("jobs");

  const searchWords = useSearchWords(query);

  return {
    searchWords,
  };
}
